import * as React from 'react'
import ReactSelect from 'react-select'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import { BREAKPOINT_TABLET_SMALL } from '../../../../static/constants'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { InputText, InputTextArea } from '../../../atoms'
import AgentLayoutNew from '../_layouts/new'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  title: 'title',
  text1: 'text1',
  text2: 'text2',
  text3: 'text3',
  post_ids: 'post_ids',
}
const title = I18n.t('admin.create_new', {
  model: I18n.t('mail_template', { scope: 'activerecord.models' }),
})
interface IProps {
  posts: IJsonResponse
  mail_template?: any
  user: IJsonResponse
}

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    border: `1px solid ${constants.COLORS.divider}`,
    borderRadius: 4,
    '&:hover': { border: `1px solid ${constants.COLORS.primary}` },
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: constants.COLORS.primary,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: constants.COLORS.white,
  }),
}
const AgentMailTemplateNew: React.FC<IProps> = props => {
  const { data: posts } = utilService.getDataFromJson(props.posts)
  const { data: user } = utilService.getDataFromJson(props.user)
  const [selectedPosts, setSelectedPosts] = React.useState(null)
  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const result = { ...values }
      result.post_ids = selectedPosts?.map(post => Number(post.value))
      const { createdMailTemplate, flush } = await agentService.createMailTemplate(result)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/mail_templates'
    },
    [selectedPosts]
  )
  return (
    <SidebarLayout user={user} showSidebar={true}>
      <AgentLayoutNew
        model="mail_template"
        hideAgentNav={true}
        title={title}
        fields={FIELDS}
        indexLink="/agent/mail_templates"
        formItems={
          <>
            <InputText
              required={true}
              name="name"
              defaultValue=""
              label="Name"
              placeholder={I18n.t('mail_template.name_placeholder')}
            />
            <S.FormItemWrapper>
              <S.ReactSelectWrapper>
                <p className="ReactSelect_Title">
                  {I18n.t('generic.tour')}
                  <span className="InputText_Required">{I18n.t('generic.required')}</span>
                </p>
                <div className="ReactSelect_Main">
                  <ReactSelect
                    placeholder={I18n.t('generic.select_tour')}
                    options={posts.map(post => ({
                      value: post.id,
                      label: post.name,
                    }))}
                    isMulti={true}
                    onChange={setSelectedPosts}
                    styles={selectCustomStyles}
                    menuPortalTarget={document.querySelector('body')}
                  />
                  <input
                    name="post_ids"
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0 }}
                    value={selectedPosts || ''}
                    required={true}
                    onChange={() => {
                      return
                    }}
                  />
                </div>
              </S.ReactSelectWrapper>
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputText
                required={true}
                name="title"
                defaultValue={props.mail_template?.data.attributes.title || ''}
                label={I18n.t('mail_template.subject')}
                placeholder={I18n.t('mail_template.subject_placeholder')}
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputTextArea
                required={false}
                name="text1"
                defaultValue={props.mail_template?.data.attributes.text1 || ''}
                label={I18n.t('mail_template.text1')}
                placeholder={I18n.t('mail_template.text1_placeholder')}
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputTextArea
                required={false}
                name="text2"
                defaultValue={props.mail_template?.data.attributes.text2 || ''}
                label={I18n.t('mail_template.text2')}
                placeholder={I18n.t('mail_template.text2_placeholder')}
              />
              <p className="note">{I18n.t('mail_template.note')}</p>
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputTextArea
                required={false}
                name="text3"
                defaultValue={props.mail_template?.data.attributes.text3 || ''}
                label="Text3"
              />
              <p className="note">
                {I18n.t('activerecord.attributes.remind_mail_template.available_variables')}
                <br />
                {I18n.t('activerecord.attributes.remind_mail_template.guest_name')}
                <br />
                {I18n.t('activerecord.attributes.remind_mail_template.review_url')}
              </p>
            </S.FormItemWrapper>
          </>
        }
        handleSubmit={handleSubmit}
      />
    </SidebarLayout>
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.FormItemWrapper = styled.div`
  margin-top: 24px;
  .note {
    margin-left: 180px;
    font-size: 14px;
    margin-top: 5px;
    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      margin-left: 0px;
    }
  }
`
S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 180px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    .InputText_Required {
      display: inline-block;
      border-radius: 3px;
      color: ${constants.COLORS.white};
      background-color: ${constants.COLORS.caution};
      vertical-align: middle;
      font-size: 11px;
      font-weight: normal;
      padding: 4px 6px;
      margin-left: 8px;
    }

    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
`

export default AgentMailTemplateNew
